import { type QueryResolvers } from '../../../../generated/graphql'
import type { ApolloResolverContext } from '@edge/spark/io-apollo'
import { getIsEditingLayouts } from '../../../../Stores'

export const isEditingLayoutsResolver: QueryResolvers<ApolloResolverContext>['isEditingLayouts'] = async () => {
    console.debug('io-dashboards isEditingLayoutsResolver deprecated, use isEditingLayouts store')

    const isEditingLayouts = getIsEditingLayouts()
    return isEditingLayouts
}
